/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {

    ADD_ITEM(state, item) {
        // let region = state.institutions.find(a => a.id === item.regionId);
        // state.institutions.unshift(item)
    },

    SET_INSTITUTION_TRANSLATIONS(state, data) {
        state.institution_translations = data.translations;
    },

    SET_INSTITUTIONS(state, institutions) {
        state.institutions = [];

        for (let i = 0; i < institutions.length; i++) {
            let region = {
                value: institutions[i].id,
                text: institutions[i].title
            };

            state.institutions.push(region)
        }
    },

}
